const categoryFeedReducer = (
    state = { categoryFeed: [], navPath: null, loading: false, error: false, hasMore: false, totalItems: 0 },
    action
) => {
    switch(action.type) {
        case "CATEGORY_FEED_START":
            return { ...state, loading: true, error: false }
        
        case "CATEGORY_FEED_SUCCESS":
            const updatedFeed = action.page === 0
                ? action.data
                : [...(state.categoryFeed || []), ...action.data];
            
            let updatedNavPath = state.navPath;
            if (!action.isScrollFetch) {
                if (action.nav === null) {
                    updatedNavPath = [];
                } else if (typeof action.nav === "object") {
                    updatedNavPath = [...state.navPath, action.nav];
                } else if (typeof action.nav === "number") {
                    updatedNavPath = [...state.navPath.slice(0, action.nav + 1)];
                }
            }
            
            return {
                ...state,
                categoryFeed: updatedFeed,
                navPath: updatedNavPath,
                hasMore: action.hasMore,
                totalItems: action.totalItems,
                loading: false,
                error: false
            }

        case "CATEGORY_FEED_FAIL":
            return { ...state, loading: false, error: true }

        case "LOG_OUT":
            return { categoryFeed: [], navPath: null, loading: false, error: false, hasMore: false }

        default:
            return state
    }
}

export default categoryFeedReducer